import * as React from "react"
const AddBOMIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} {...props}>
    <g data-name="Group 115872">
      <path
        fill="#4e5a6b"
        d="M2.2 1.116a2.209 2.209 0 0 0-2.2 2.2v8.4a2.209 2.209 0 0 0 2.2 2.2h11.6a2.209 2.209 0 0 0 2.2-2.2v-8.4a2.209 2.209 0 0 0-2.2-2.2Zm0 1.2h11.6a.991.991 0 0 1 1 1v8.4a.991.991 0 0 1-1 1H2.2a.991.991 0 0 1-1-1v-8.4a.991.991 0 0 1 1-1Zm1.2 2.4a.6.6 0 1 0 0 1.2h6a.6.6 0 1 0 0-1.2Zm8.4 0a.6.6 0 1 0 0 1.2h.8a.6.6 0 1 0 0-1.2Zm-8.4 2.4a.6.6 0 1 0 0 1.2h6a.6.6 0 1 0 0-1.2Zm8.4 0a.6.6 0 1 0 0 1.2h.8a.6.6 0 1 0 0-1.2Zm0 2.4a.6.6 0 1 0 0 1.2h.8a.6.6 0 1 0 0-1.2Z"
        data-name="icons8-bill (7)"
      />
    </g>
  </svg>
)
export default AddBOMIcon
